module.exports = __webpack_public_path__ + "img/165.0fe07452.jpg";